const firebaseConfig = {
    apiKey: "AIzaSyBemlyWiSPM-hLZ9sCIkJ8HVv8IQbg-Euc",
    authDomain: "tree-station.firebaseapp.com",
    projectId: "tree-station",
    storageBucket: "tree-station.appspot.com",
    messagingSenderId: "284527743405",
    appId: "1:284527743405:web:85a14f075bce1bb1515124"
};

export default firebaseConfig;